module.exports = {
  routes: {
    auth: "/[teamSchema]/auth",
    checkoutStatus: "/[teamSchema]/checkout_status",
    giftCard: "/[teamSchema]/gift_card",
    gift: "/[teamSchema]/gift",
    redeem: "/[teamSchema]/redeem",
    redeemGiftCard: "/[teamSchema]/redeem",
    giftCardNoQuery: "/gift_card",
    redeemGiftCardNoQuery: "/redeem",
    landing: "/[teamSchema]/landing",
    landingNoQuery: "/landing",
    oauth: "/[teamSchema]/tmauth",
    oauthNoQuery: "tmauth",
    purchaseHistory: "/[teamSchema]/purchase_history",
    purchaseSeats: "/[teamSchema]/purchase_seats",
    purchaseCredit: "/[teamSchema]/purchase_credit",
    termsAndConditions: "/[teamSchema]/gift_terms_and_conditions",
    manageCard: "/[teamSchema]/manage_card",

    // ticket transfer routes
    ticket_transfer: "/[teamSchema]/ticket_transfer",
    link_ticket_transfer: "/[teamSchema]/link_ticket_transfer",
    houston_astros_terms_and_conditions:
      "/[teamSchema]/houston_astros_terms_and_conditions",
    prudentialcenter_terms_and_conditions:
      "/[teamSchema]/prudentialcenter_terms_and_conditions",
  },
};
